import { optional, tryNew } from '@/helpers/dto2resource';
import PropostaDto from '../dto/PropostaDto';
import { StatusProposta } from '../enums';
import MeioPagamento from '../enums/MeioPagamento';
import DetalhesPropostaResource from './DetalhesPropostaResource';
import OfertaResource from './OfertaResource';
import ParcelasGerenciadasResource from './ParcelasGerenciadasResource';

export default class PropostaResource {
  id: number;
  dataProposta?: Date;
  quantidadeParcelas: number;
  valorParcela: number;
  valorEntrada: number;
  dividaId: number;
  dataPrimeiroBoleto: Date;
  status: StatusProposta;
  valorTotal: number;
  detalhe?: DetalhesPropostaResource;
  detalheDescricao?: string;
  possuiEntrada: boolean;
  possuiTermoAcordo?: boolean;
  quantidadeParcelasMaisEntrada: number;
  oferta?: OfertaResource;
  permiteCancelamento: boolean;
  urlTermoAcordo?: string;
  meioPagamentoEscolhido: MeioPagamento;
  meiosPagamentoPrimeiraParcela: MeioPagamento[];
  meiosPagamentoDemaisParcelas: MeioPagamento[];
  parcelasGerenciadas: ParcelasGerenciadasResource;

  constructor(resource: PropostaDto) {
    this.id = resource.id;
    if (resource.dataProposta) this.dataProposta = new Date(resource.dataProposta);
    this.quantidadeParcelas = resource.quantidadeParcelas;
    this.valorParcela = resource.valorParcela;
    this.valorEntrada = resource.valorEntrada;
    this.dividaId = resource.dividaId;
    this.dataPrimeiroBoleto = new Date(resource.dataPrimeiroBoleto);
    this.status = resource.status;
    this.valorTotal = resource.valorTotal;

    this.detalhe = typeof resource.detalhe === 'string'
      ? DetalhesPropostaResource.fromWhiteLabel(resource.detalhe)
      : tryNew(DetalhesPropostaResource, resource.detalhe);
    this.detalheDescricao = this.detalhe?.descricao;

    this.possuiEntrada = resource.possuiEntrada;
    this.possuiTermoAcordo = optional(resource.possuiTermoAcordo);
    this.quantidadeParcelasMaisEntrada = resource.quantidadeParcelasMaisEntrada;
    this.oferta = resource.oferta ? new OfertaResource(resource.oferta) : undefined;
    this.permiteCancelamento = !!resource.permiteCancelamento;
    this.meioPagamentoEscolhido = resource.meioPagamentoEscolhido;
    this.urlTermoAcordo = resource.urlTermoAcordo ?? undefined;
    this.meiosPagamentoPrimeiraParcela = resource.meiosPagamentoPrimeiraParcela
      ?? [MeioPagamento.Boleto];
    this.meiosPagamentoDemaisParcelas = resource.meiosPagamentoDemaisParcelas ?? [];
    this.parcelasGerenciadas = new ParcelasGerenciadasResource(resource.parcelasGerenciadas);
  }

  get valorTotalCalculado(): number {
    return this.valorEntrada + this.quantidadeParcelas * this.valorParcela;
  }

  get vencimentoDemaisBoletos(): Date {
    return this.oferta?.dataProximoBoleto ?? this.dataPrimeiroBoleto;
  }
}
